import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="checklists" />;

export const Route = createFileRoute("/zh-cn/downloads/checklists/$slug")({
  loader: ({ params }) => loadContentMeta("checklists", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/downloads/checklists/${params.slug}`, loaderData),
  component: ContentPostRoute,
});
